import { Button, Stack } from '@mui/material'
import { useMemo } from 'react'
import { Link } from 'react-router'

import { routes } from '~/features/routes'
import { CustomDataGrid } from '~/ui/components/CustomDataGrid'
import { useGetAgencies } from './hooks/useGetAgencies'

export const AgencyList = () => {
  const { data: agencies, isLoading } = useGetAgencies()

  const columns = useMemo(() => {
    return [
      {
        field: 'agency_name',
        headerName: 'Name',
        flex: 1,
      },
      { field: 'agency_id', headerName: 'Agency ID', flex: 1 },
      { field: 'commission', headerName: 'Commission %', flex: 1 },
      { field: 'min_commission', headerName: 'Min Commission', flex: 1 },
    ]
  }, [])

  return (
    <Stack sx={{ height: 1 }}>
      <Button
        component={Link}
        to={routes.createAgency.route}
        variant="contained"
        sx={{ alignSelf: 'flex-end' }}
      >
        Create new
      </Button>
      <CustomDataGrid columns={columns} rows={agencies ?? []} loading={isLoading} />
    </Stack>
  )
}
